import { Toolbar, Skeleton, Box } from '@mui/material';

export const MobileHeaderSkeleton: React.FC = () => {
  return (
    <Toolbar disableGutters className="container-fluid">
      <Skeleton variant="circular" width={40} height={40} />
      <Box sx={{ mx: 'auto' }}>
        <Skeleton variant="rectangular" width={100} height={30} />
      </Box>
      <Skeleton variant="circular" width={40} height={40} />
    </Toolbar>
  );
};
